import SimpleLayout from './SimpleLayout';

export default SimpleLayout;
